namespace $.$$ {
	export class $bog_sum extends $.$bog_sum {
		@$mol_mem
		result() {
			return `${this.a().toFixed(2)} + ${this.b()} = ${this.a() + this.b()}`
		}
	}
}
